import React, { useId } from "react";

const RequestCategoryToggle = ({ activeTab, setActiveTab }) => {
  const uid = useId();
  const leaveId = `${uid}-leave`;
  const wfhId = `${uid}-wfh`;

  return (
    <div className="btn-group mb-3" role="group" aria-label="Request Category">
      <input
        type="radio"
        className="btn-check"
        name={`requestCategory-${uid}`}
        id={leaveId}
        autoComplete="off"
        checked={activeTab === "Leave"}
        onChange={() => setActiveTab("Leave")}
      />
      <label
        className="btn"
        htmlFor={leaveId}
        style={
          activeTab === "Leave"
            ? { backgroundColor: "var(--primary-color)", borderColor: "var(--primary-color)", color: "#fff" }
            : { backgroundColor: "#fff", borderColor: "var(--primary-color)", color: "var(--primary-color)" }
        }
      >
        Leave
      </label>

      <input
        type="radio"
        className="btn-check"
        name={`requestCategory-${uid}`}
        id={wfhId}
        autoComplete="off"
        checked={activeTab === "WFH/BT"}
        onChange={() => setActiveTab("WFH/BT")}
      />
      <label
        className="btn"
        htmlFor={wfhId}
        style={
          activeTab === "WFH/BT"
            ? { backgroundColor: "var(--primary-color)", borderColor: "var(--primary-color)", color: "#fff" }
            : { backgroundColor: "#fff", borderColor: "var(--primary-color)", color: "var(--primary-color)" }
        }
      >
        WFH/BT
      </label>
    </div>
  );
};

export default RequestCategoryToggle;
